export enum MapAreaOverlay {
  Id = 'area-overlay',
  Layer = 'overlay',
  Border = 'overlay-border',
}
